import React from "react";
import PerfectScrollbar from "perfect-scrollbar"
import { Route, Switch, Redirect } from "react-router-dom"
import AdminNavbar from "components/Navbars/AdminNavbar"
import Footer from "components/Footer"
import Sidebar from "components/Sidebar"

import rotasMapeadas from "routes.js"
import rotas from '../services/rotas'
import rest from '../lib/rest'
import AuthContext from '../authContext'
import Loading from 'lib/loading'

var ps;

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: "white",
      activeColor: "primary",
      sidebarMini: false,
      isLoading: false,
      routes: [],
      redirectToLogin: false,
      token: '',
      rede: '',
      usuario:''
    };
  }
  async componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on"
      document.documentElement.classList.remove("perfect-scrollbar-off")
      ps = new PerfectScrollbar(this.refs.mainPanel)
    }
    try {
      this.setState({ isLoading: true })
      const rotasMenu = await rest.post(rotas.menu)
      if (rotasMenu.erro === 'sim') {

        // alert(rotasMenu.msg)

        sessionStorage.removeItem('token')
        this.setState({ redirectToLogin: true })
      }

      this.setState({
        routes: rotasMenu.menu
      })
      this.setState({ isLoading: false })
    } catch (err) {
      sessionStorage.removeItem('token')
      this.setState({ redirectToLogin: true })

    }
    // para injetar no context
    const token = sessionStorage.getItem('token')
    if (token) {
      const rede    = sessionStorage.getItem('rede'),
            usuario = sessionStorage.getItem('usuario')
      this.setState({ token, rede, usuario })

    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off"
      document.documentElement.classList.remove("perfect-scrollbar-on")
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop  = 0
      document.scrollingElement.scrollTop = 0
      this.refs.mainPanel.scrollTop       = 0
    }
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views)
      }
      if (prop.layout === "/painelwebgestor/admin") {
        return (
          <Route
            path      = {prop.layout + prop.path}
            component = {prop.component}
            key       = {key}
          />
        );
      } else {
        return null;
      }
    });
  };
  handleActiveClick = color => {
    this.setState({ activeColor: color })
  };
  handleBgClick = color => {
    this.setState({ backgroundColor: color })
  };
  handleMiniClick = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false })
    } else {
      this.setState({ sidebarMini: true })
    }
    document.body.classList.toggle("sidebar-mini");
  };
  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/painelwebgestor/auth/login' />
    }
    if (this.state.isLoading) {
      return (

        <Loading
          tipo='preloader'
        />
      )
    }
    const routes = this.state.routes.map(rota => {
      if (!rota.collapse) {
        return {
          ...rota,
          component: rotasMapeadas[rota.component]
        }
      }
      return {
        ...rota,
        views: rota.views.map(subRota => ({
          ...subRota,
          component: rotasMapeadas[subRota.component]
        }))
      }
    })

    return (
      <div>
        <AuthContext.Provider value={{
          token: this.state.token,
          rede: this.state.rede,
          usuario: this.state.usuario
        }}>
          <Sidebar
            {...this.props}
            routes      = {routes}
            bgColor     = {this.state.backgroundColor}
            activeColor = {this.state.activeColor}
          />
            <div className="main-panel" ref="mainPanel">
            <AdminNavbar {...this.props} handleMiniClick={this.handleMiniClick} />
            <Switch>{this.getRoutes(routes)}{routes.length > 0 && <Redirect to="/painelwebgestor/admin/principal" />}</Switch>
            {// we don't want the Footer to be rendered on full screen maps page
              this.props.location.pathname.indexOf("full-screen-map") !==
                -1 ? null : (
                  <Footer fluid />
                )}
          </div>
        </AuthContext.Provider>
      </div>
    );
  }
}

//(className="wrapper") - Caso tenha algum problemas voltar com essa classe na div do return.

export default Admin
